/**
 *
 * key
 *
 */

 const key = 'ZW1zUmVzZXRQYXNzd29yZA=='

 export default key
 